import find from 'lodash.find';
import config from '../config';
import http from '../utilities/http';
import { set, get } from '../utilities/storage';
import { CONTACTS, CONTRACTS, CONTACTS_AND_CONTRACTS } from '../constants/storage';

/**
 * Get all contacts.
 */
export async function getAllContacts() {
  return await http
    .get(config.endpoints.contact.getAll)
    .then(function (res) {
      return res;
    })
    .catch(function (error) {
      return [];
    });
}

/**
 * Get all contracts.
 */
export async function getAllContracts() {
  return await http
    .get(config.endpoints.contract.getAll)
    .then(function (res) {
      return res;
    })
    .catch(function (error) {
      return [];
    });
}

/**
 * Persist contacts
 */
export async function setContacts(contacts) {
  set(CONTACTS, contacts);
}

/**
 * Persist contracts
 */
export async function setContracts(contracts) {
  set(CONTRACTS, contracts);
}

/**
 * Persist contacts and contracts
 */
export async function setContactsAndContracts(contactsAndContracts) {
  set(CONTACTS_AND_CONTRACTS, contactsAndContracts);
}

/**
 * Resolve contact or contract name
 */
export function resolveAddress(address, type = null) {
  let address_list = [];

  if (type === 'contract') {
    address_list = get(CONTRACTS);
  } else if (type === 'contact') {
    address_list = get(CONTACTS);
  } else {
    address_list = get(CONTACTS_AND_CONTRACTS);
  }

  if (!address_list || !address_list.length) {
    return address;
  }

  let resolved_address = find(address_list, { address });

  return resolved_address ? { name: resolved_address.name } : { address: address };
}
